var p = { exports: {} }, c = typeof Reflect == "object" ? Reflect : null, L = c && typeof c.apply == "function" ? c.apply : function(e, n, r) {
  return Function.prototype.apply.call(e, n, r);
}, g;
c && typeof c.ownKeys == "function" ? g = c.ownKeys : Object.getOwnPropertySymbols ? g = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : g = function(e) {
  return Object.getOwnPropertyNames(e);
};
function O(t) {
  console && console.warn && console.warn(t);
}
var C = Number.isNaN || function(e) {
  return e !== e;
};
function s() {
  s.init.call(this);
}
p.exports = s;
p.exports.once = j;
s.EventEmitter = s;
s.prototype._events = void 0;
s.prototype._eventsCount = 0;
s.prototype._maxListeners = void 0;
var m = 10;
function d(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(s, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return m;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || C(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    m = t;
  }
});
s.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
s.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || C(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function b(t) {
  return t._maxListeners === void 0 ? s.defaultMaxListeners : t._maxListeners;
}
s.prototype.getMaxListeners = function() {
  return b(this);
};
s.prototype.emit = function(e) {
  for (var n = [], r = 1; r < arguments.length; r++)
    n.push(arguments[r]);
  var o = e === "error", a = this._events;
  if (a !== void 0)
    o = o && a.error === void 0;
  else if (!o)
    return !1;
  if (o) {
    var i;
    if (n.length > 0 && (i = n[0]), i instanceof Error)
      throw i;
    var l = new Error("Unhandled error." + (i ? " (" + i.message + ")" : ""));
    throw l.context = i, l;
  }
  var f = a[e];
  if (f === void 0)
    return !1;
  if (typeof f == "function")
    L(f, this, n);
  else
    for (var v = f.length, x = N(f, v), r = 0; r < v; ++r)
      L(x[r], this, n);
  return !0;
};
function y(t, e, n, r) {
  var o, a, i;
  if (d(n), a = t._events, a === void 0 ? (a = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (a.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    n.listener ? n.listener : n
  ), a = t._events), i = a[e]), i === void 0)
    i = a[e] = n, ++t._eventsCount;
  else if (typeof i == "function" ? i = a[e] = r ? [n, i] : [i, n] : r ? i.unshift(n) : i.push(n), o = b(t), o > 0 && i.length > o && !i.warned) {
    i.warned = !0;
    var l = new Error("Possible EventEmitter memory leak detected. " + i.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = i.length, O(l);
  }
  return t;
}
s.prototype.addListener = function(e, n) {
  return y(this, e, n, !1);
};
s.prototype.on = s.prototype.addListener;
s.prototype.prependListener = function(e, n) {
  return y(this, e, n, !0);
};
function P() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function w(t, e, n) {
  var r = { fired: !1, wrapFn: void 0, target: t, type: e, listener: n }, o = P.bind(r);
  return o.listener = n, r.wrapFn = o, o;
}
s.prototype.once = function(e, n) {
  return d(n), this.on(e, w(this, e, n)), this;
};
s.prototype.prependOnceListener = function(e, n) {
  return d(n), this.prependListener(e, w(this, e, n)), this;
};
s.prototype.removeListener = function(e, n) {
  var r, o, a, i, l;
  if (d(n), o = this._events, o === void 0)
    return this;
  if (r = o[e], r === void 0)
    return this;
  if (r === n || r.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete o[e], o.removeListener && this.emit("removeListener", e, r.listener || n));
  else if (typeof r != "function") {
    for (a = -1, i = r.length - 1; i >= 0; i--)
      if (r[i] === n || r[i].listener === n) {
        l = r[i].listener, a = i;
        break;
      }
    if (a < 0)
      return this;
    a === 0 ? r.shift() : R(r, a), r.length === 1 && (o[e] = r[0]), o.removeListener !== void 0 && this.emit("removeListener", e, l || n);
  }
  return this;
};
s.prototype.off = s.prototype.removeListener;
s.prototype.removeAllListeners = function(e) {
  var n, r, o;
  if (r = this._events, r === void 0)
    return this;
  if (r.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[e]), this;
  if (arguments.length === 0) {
    var a = Object.keys(r), i;
    for (o = 0; o < a.length; ++o)
      i = a[o], i !== "removeListener" && this.removeAllListeners(i);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = r[e], typeof n == "function")
    this.removeListener(e, n);
  else if (n !== void 0)
    for (o = n.length - 1; o >= 0; o--)
      this.removeListener(e, n[o]);
  return this;
};
function k(t, e, n) {
  var r = t._events;
  if (r === void 0)
    return [];
  var o = r[e];
  return o === void 0 ? [] : typeof o == "function" ? n ? [o.listener || o] : [o] : n ? A(o) : N(o, o.length);
}
s.prototype.listeners = function(e) {
  return k(this, e, !0);
};
s.prototype.rawListeners = function(e) {
  return k(this, e, !1);
};
s.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : E.call(t, e);
};
s.prototype.listenerCount = E;
function E(t) {
  var e = this._events;
  if (e !== void 0) {
    var n = e[t];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
s.prototype.eventNames = function() {
  return this._eventsCount > 0 ? g(this._events) : [];
};
function N(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r)
    n[r] = t[r];
  return n;
}
function R(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function A(t) {
  for (var e = new Array(t.length), n = 0; n < e.length; ++n)
    e[n] = t[n].listener || t[n];
  return e;
}
function j(t, e) {
  return new Promise(function(n, r) {
    function o(i) {
      t.removeListener(e, a), r(i);
    }
    function a() {
      typeof t.removeListener == "function" && t.removeListener("error", o), n([].slice.call(arguments));
    }
    _(t, e, a, { once: !0 }), e !== "error" && z(t, o, { once: !0 });
  });
}
function z(t, e, n) {
  typeof t.on == "function" && _(t, "error", e, n);
}
function _(t, e, n, r) {
  if (typeof t.on == "function")
    r.once ? t.once(e, n) : t.on(e, n);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function o(a) {
      r.once && t.removeEventListener(e, o), n(a);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
const h = [
  { translatedLabel: "Deutsch", label: "German", languageCode: "de", localization: "DE" },
  { translatedLabel: "English", label: "English", languageCode: "en", localization: "US" },
  { translatedLabel: "Español", label: "Spanish", languageCode: "es", localization: "ES" },
  { translatedLabel: "Français", label: "French", languageCode: "fr", localization: "FR" },
  { translatedLabel: "Pусский", label: "Russian", languageCode: "ru", localization: "RU" },
  { translatedLabel: "中文", label: "Chinese", languageCode: "zh", localization: "CN" },
  { translatedLabel: "日本語", label: "Japanese", languageCode: "ja", localization: "JP" },
  { translatedLabel: "Italiano", label: "Italian", languageCode: "it", localization: "IT" },
  { translatedLabel: "Português", label: "Portuguese", languageCode: "pt", localization: "PT" },
  { translatedLabel: "Polski", label: "Polish", languageCode: "pl", localization: "PL" },
  { translatedLabel: "한국인", label: "Korean", languageCode: "ko", localization: "KR" },
  { translatedLabel: "Nederlandse", label: "Dutch", languageCode: "nl", localization: "NL" },
  { translatedLabel: "Türkçe", label: "Turkish", languageCode: "tr", localization: "TR" }
];
class u extends p.exports.EventEmitter {
  static getInstance() {
    return this.instance === null && (this.instance = new u()), this.instance;
  }
  constructor() {
    super();
    const e = window;
    e != null && e.cookieStore != null && (e.cookieStore.onchange = (n) => {
      var r;
      const o = (r = n.changed.find((a) => a.name === u.LhLanguageCookieName)) === null || r === void 0 ? void 0 : r.value;
      o && this.emit("onLanguageChange", o);
    });
  }
  static getCoreLanguages() {
    return h;
  }
  static async getCurrentLanguage(e = null) {
    const n = await this.getCurrentLanguageFromAllPossibleLocations();
    return (e === null || e.length === 0) && (e = h.map((r) => r.languageCode)), e.some((r) => r === n) ? n : u.DefaultLanguage;
  }
  static async getCurrentLanguageFromAllPossibleLocations() {
    const e = await this.getLanguageFromCookie(u.LhLanguageCookieName);
    if (e != null && e != "")
      return e;
    const n = await this.getLanguageFromCookie(u.AspNetCoreLanguageCookieName);
    if (n != null && n != "") {
      const i = /uic=([a-z]+(-[a-z]+)*)/i.exec(n);
      return i && i[1].slice(0, 2);
    }
    const r = await this.getLanguageFromCookie(u.JavaSpringLanguageCookieName);
    return r != null && r != "" ? r.slice(0, 2) : (navigator.language || window.navigator.userLanguage).slice(0, 2);
  }
  static async getLanguageFromCookie(e) {
    let n = null;
    const r = window;
    if (r != null && r.cookieStore != null)
      return n = await r.cookieStore.get(e), n == null ? void 0 : n.value;
    {
      const o = document.cookie.split(";").map((a) => {
        const [i, ...l] = a.split("="), f = l.join("=");
        return [i, f];
      }).filter((a) => a[0].trim() == e).map((a) => a[1].trim());
      return o.length == 1 ? o[0] : null;
    }
  }
  static setLanguage(e) {
    document.documentElement.setAttribute("lang", e), this.setLanguageCookies(e);
  }
  static setLanguageCookies(e) {
    u.setCookieByName("lh_language", e);
    const n = h.find((r) => r.languageCode === e);
    n !== void 0 && (u.setCookieByName(u.AspNetCoreLanguageCookieName, `c=${n.languageCode}|uic=${n.languageCode}`), u.setCookieByName(u.JavaSpringLanguageCookieName, `${n.languageCode}-${n.localization}`));
  }
  static setCookieByName(e, n) {
    const r = "2147483647", o = document.domain.split(".").slice(-2).join("."), a = e + "=" + n + "; max-age=" + r + "; path=/; domain=" + o;
    document.cookie = a;
  }
  /**
   * Resolves a json object based on a language string.
   * If the string does not match any existing key, en is used as fallback.
   * @param lang Current language string.
   * @param json Object of available json objects.
   * @returns A single json object.
   */
  static resolveJsonBasedOnLanguage(e, n) {
    var r, o;
    return (o = (r = n[e]) === null || r === void 0 ? void 0 : r.default) !== null && o !== void 0 ? o : n.en.default;
  }
}
u.LhLanguageCookieName = "lh_language";
u.AspNetCoreLanguageCookieName = ".AspNetCore.Culture";
u.JavaSpringLanguageCookieName = "org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE";
u.DefaultLanguage = "en";
u.instance = null;
export {
  u as T
};
